import React, { useState } from "react"
import { Row, Col } from "react-bootstrap"
import { putPartnerUuidFleetsUuid } from "@src/api"
import { InputField, Page } from "@src/components"
import { usePartner } from "@src/partner"
import { FleetsTabs } from "./tabs"
import { useFleets } from "./useFleets"

export const FleetsDetailScreen: React.FC = () => {
  const { fleet, updateFleets } = useFleets()
  const { partner } = usePartner()
  const [loadingField, setLoadingField] = useState<string>("")
  const onInputPersist = (field: string) => (text: string) => {
    setLoadingField(field)
    const fleetData = { fleet: { name: text, contact_attributes: null } }
    putPartnerUuidFleetsUuid(partner.uuid, fleet.uuid, fleetData).then(({ response, data }) => {
      if (response.ok) updateFleets()
      setLoadingField("")
    })
  }

  return (
    <div>
      <Page isSettings>
        <div>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <InputField
                value={fleet && fleet.name}
                onPersist={onInputPersist("name")}
                loading={loadingField == "name"}
              />
            </Col>
          </Row>
          <FleetsTabs />
        </div>
      </Page>
    </div>
  )
}
